import * as THREE from 'three';
import Stats from 'three/examples/jsm/libs/stats.module.js';
import { OrbitControls } from './controls/OrbitControls';
import CollisionObject from '@blade-sxp/map/src/objects/CollisionObject';
// import { CSS2DRenderer } from 'three/examples/jsm/renderers/CSS2DRenderer';
import { CSS2DRenderer } from './renderer/CSS3DRenderer';
// import { OctreeHelper } from '@blade-sxp/map/src/helpers/OctreeHelper';
import TWEEN from '@tweenjs/tween.js';
import { WebGLRenderer } from './renderer/WebGLRenderer';
import { isElement } from '../utils';
import InteractControls from './controls/InteractControls';
import CapsuleControls from './controls/CapsuleControls';
import Objects from './element';
import Weather from './element/weather';
import store from './store';
import { GLTFLoader } from './loaders/GLTFLoader';
import screenStore from '@blade-sxp/screen/store/index';
var MapUpdateType;
(function (MapUpdateType) {
    MapUpdateType[MapUpdateType["element"] = 0] = "element";
    MapUpdateType[MapUpdateType["scene"] = 1] = "scene";
})(MapUpdateType || (MapUpdateType = {}));
class BaseMap extends THREE.EventDispatcher {
    intersects; // 光线投影控制器（获取当前对象）
    renderer; // WebGLRenderer
    _labelRender; // CSS2dRender
    container; // 宿主DOM
    stats; // FPS检测器
    _elements = []; // 数据源
    controls; // 轨道控制器
    scene; // 场景
    animate; // 动画
    _elementMap; // 所有元素存储
    _collectElements = new Map(); // 数据源
    _group; // 初始化分组
    _toolGroup; // 初始化工具分组
    _asyncTag; // 是否是异步标志
    _tempList; // 暂存数据变化数组
    debug; // debug模式
    defaultZoom;
    minZoom;
    maxZoom;
    animateId;
    mainAngle;
    ambientLight;
    capsule;
    operationMode = 'sandTable';
    // private aircraft?: THREE.Mesh;
    aircraft;
    aircraftMixer;
    aircraftFlyAction;
    person;
    delayTimer;
    _backgroundColor = '';
    clock;
    _onload;
    update;
    destory;
    onClick;
    onMouseDown;
    onMouseEnter;
    onMouseLeave;
    onMouseMove;
    onMouseUp;
    camera; // 相机
    weather;
    preRenderTime = 0;
    interval = 0; // 渲染间隔时间
    frameTime = 1000 / 30; // 每秒至少刷新30次
    smoothTimes = 0; // 每秒至少刷新30次
    collisionObject;
    // public elements: any[];
    constructor(data) {
        super();
        const { container, autoRotate = false, debug = false, elements, zoom, minZoom, maxZoom, mouseLeft = 'PAN', enableDamping = true, mouseMiddle = 'DOLLY', mouseRight = 'ROTATE', backgroundColor = '#fff', } = data;
        // Error
        if (!container || !isElement(container))
            throw new TypeError('canvas类型有误');
        // Init
        this.container = container;
        this._elementMap = new Map();
        this._onload = null;
        this.update = null;
        this.onClick = undefined;
        this.onMouseMove = undefined;
        this.onMouseEnter = undefined;
        this.onMouseLeave = undefined;
        this.onMouseDown = undefined;
        this.onMouseUp = undefined;
        this._asyncTag = false;
        this._tempList = [];
        this.debug = debug;
        this.defaultZoom = zoom;
        this.minZoom = minZoom;
        this.maxZoom = maxZoom;
        this.animateId = -1;
        this.delayTimer = 0;
        // Scene
        this.scene = new THREE.Scene();
        store.scene = this.scene;
        this.mapBackgroundColor = backgroundColor;
        // this.scene.background = new THREE.Color(backgroundColor);
        // Sizes
        const sizes = {
            width: this.container.clientWidth,
            height: this.container.clientHeight,
        };
        // Camera
        this.camera = new THREE.PerspectiveCamera(45, sizes.width / sizes.height, 10, 15000);
        store.camera = this.camera;
        this.camera.position.set(0, 10, 10);
        this.camera.updateProjectionMatrix();
        // const cameraDefaultZoom = zoomToCameraPositionZ(zoom); // 镜头默认高度
        // this.camera.position.set(0, 0, cameraDefaultZoom);
        this.scene.add(this.camera);
        // add listener
        this.EventHandler = this.EventHandler.bind(this);
        this._resize = this._resize.bind(this);
        this.destory = this.dispose.bind(this);
        window.addEventListener('resize', this._resize, false);
        // Renderer
        this.renderer = new WebGLRenderer({ antialias: true, alpha: true, depth: true });
        this.renderer.setSize(sizes.width, sizes.height);
        this.renderer.outputEncoding = THREE.sRGBEncoding;
        this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        this.renderer.shadowMap.enabled = true;
        store.renderer = this.renderer;
        this.renderer.toneMappingExposure = 1;
        // Group
        this._group = new THREE.Group();
        this._group.name = '3d-group';
        this.scene.add(this._group);
        this._toolGroup = new THREE.Group();
        this.scene.add(this._toolGroup);
        store.toolGroup = this._toolGroup;
        // Add Elements
        // this._handleElementChange();
        this.elements = elements;
        // CSS2DRenderer
        this._labelRender = new CSS2DRenderer();
        this._labelRender.setSize(sizes.width, sizes.height);
        this._labelRender.domElement.style.position = 'absolute';
        this._labelRender.domElement.style.top = '0px';
        // domRender
        this.container.appendChild(this.renderer.domElement);
        this.container.appendChild(this._labelRender.domElement);
        // OrbitControls
        this.controls = new OrbitControls(this.camera, this.container);
        store.controls = this.controls;
        this.controls.minPolarAngle = 0;
        this.controls.maxPolarAngle = Math.PI / 2;
        this.controls.minDistance = 0;
        this.controls.minZoom = 2;
        // this.controls.maxPolarAngle = Math.PI / 2 - Math.PI / 64;
        // this.controls.minDistance = 2 / Math.sin(Math.PI / 64);
        this.controls.maxDistance = 3000;
        this.controls.screenSpacePanning = false;
        this.controls.autoRotate = autoRotate;
        this.controls.autoRotateSpeed = 1.0 * 0.2;
        this.controls.enableDamping = enableDamping;
        this.controls.dampingFactor = 0.5;
        this.controls.enableKeys = true;
        this.controls.keyPanSpeed = 10;
        this.controls.keys = {
            LEFT: [37, 65],
            UP: [38, 87],
            RIGHT: [39, 68],
            BOTTOM: [40, 83],
            RISE: [69, 33],
            FALL: [81, 34],
            UPSHIFT: [16],
            SWITCH: [67], // 视角切换
        };
        this.controls.onViewChange = (value) => {
            // this.setFlyMode();
            if (this.aircraft)
                this.aircraft.visible = !this.aircraft.visible;
        };
        // this.resetWeather();
        // InteractControls  监听所有 element
        this.intersects = new InteractControls(this.camera, this.container, this.scene, false);
        this.intersects.addEventListener('mousedown', this.EventHandler);
        this.intersects.addEventListener('mouseup', this.EventHandler);
        this.intersects.addEventListener('mousemove', this.EventHandler);
        this.intersects.addEventListener('click', this.EventHandler);
        this.intersects.addEventListener('mouseenter', this.EventHandler);
        this.intersects.addEventListener('mouseleave', this.EventHandler);
        store.onGltfUpdate(() => {
            // 八叉树初始化场景用于碰撞检测
            // this.worldOctree.fromGraphNode(this.scene);
            this.modelLoadedEvent(); // 模型加载完毕，解析数据
        });
        this.capsule = new CapsuleControls();
        store.capsule = this.capsule;
        // 平行光1
        // const directionalLight = new THREE.DirectionalLight(0xffffff, 0.6); // 光的颜色，光照强度
        // directionalLight.position.set(400, 200, 300);
        // this.scene.add(directionalLight);
        // 环境光
        // const ambient = new THREE.AmbientLight(0xffffff, 1);
        // this.scene.add(ambient);
        // this.scene.background = new THREE.Color(0xffffff);
        // 主视角初始化
        this.mainAngle = {
            target: this.controls.target,
            camera: this.camera.position,
        };
        // Debug
        if (debug) {
            // 添加坐标轴
            const axesHelper = new THREE.AxesHelper(5000);
            // axesHelper.position.z = -1;
            this.scene.add(axesHelper);
            // 添加FPS检测
            this.stats = new Stats();
            this.container.appendChild(this.stats.dom);
        }
        // Clock
        // const clock = new THREE.Clock();
        // Animations
        this.animate = () => {
            // this.requestIdleCallback(this.animate);
            this.animateId = window.requestAnimationFrame(this.animate);
            this.render();
        };
        this.animate();
        if (this._onload) {
            this._onload();
        }
        else {
            this._onload = true;
        }
    }
    // 获取/设置onload事件
    get onload() {
        return this._onload;
    }
    set onload(value) {
        if (this._onload) {
            value();
        }
        this._onload = value;
    }
    // 获取/设置background
    get mapBackgroundColor() {
        return this._backgroundColor;
    }
    set mapBackgroundColor(value) {
        this._backgroundColor = value;
    }
    setPrimaryMode() {
        this.controls.enableKeys = true;
        this.controls.keyPanSpeed = 5;
        this.controls.enablePan = true;
        this.controls.maxDistance = 3000;
        this.controls.enableZoom = true;
        this.controls.capsuleEnable = false;
        this.controls.isThirdPerspective = true;
        this.controls.keys = {
            LEFT: [37, 65],
            UP: [38, 87],
            RIGHT: [39, 68],
            BOTTOM: [40, 83],
            RISE: [69, 33],
            FALL: [81, 34],
            UPSHIFT: [16],
            SWITCH: [], // 视角切换
        };
        this.controls.shiftKey = false;
        if (this.aircraft) {
            this.aircraft.traverse((obj) => {
                if (obj instanceof THREE.Mesh) {
                    obj.geometry.dispose();
                    obj.material.dispose();
                }
                if (obj.parent) {
                    obj?.parent.remove(obj);
                }
                obj.clear();
            });
            this.scene.remove(this.aircraft);
            this.aircraft = undefined;
            this.camera.near = 10;
        }
        if (this.collisionObject) {
            this.collisionObject.dispose();
            this.collisionObject = undefined;
            this.camera.near = 10;
        }
        this.camera.updateProjectionMatrix();
    }
    async setFlyMode() {
        this.controls.capsuleEnable = true;
        this.controls.enablePan = false;
        this.controls.enableZoom = true;
        this.camera.near = 0.1;
        this.controls.isThirdPerspective = true;
        this.controls.keys.SWITCH = [67];
        this.clock = new THREE.Clock(); // 创建时钟
        if (this.controls.isThirdPerspective) {
            // 如果第三视角则生成一个飞机在镜头下方
            if (!this.aircraft) {
                let fn;
                const loader = new GLTFLoader();
                loader.load('/aircraft01/WuRenJi.gltf', (obj) => {
                    this.aircraft = obj.scene;
                    this.aircraft.name = 'aircraft';
                    this.aircraft.scale.set(1, 1, 1);
                    this.aircraftMixer = new THREE.AnimationMixer(this.aircraft);
                    const animation = obj.animations[1];
                    this.aircraftFlyAction = this.aircraftMixer.clipAction(animation);
                    // this.aircraftFlyAction.timeScale = 3;
                    fn && fn(true);
                });
                await new Promise((resolve, reject) => {
                    fn = resolve;
                });
            }
            else {
                this.aircraft.visible = true;
            }
            this.scene.add(this.aircraft);
            this.camera.updateProjectionMatrix();
            this.aircraftFlyAction?.play();
            this.updateAircraft();
        }
        else if (this.aircraft) {
            // this.scene.remove(this.aircraft);
            this.aircraft.visible = false;
        }
    }
    updateAircraft = (function (scope) {
        let angle = 0;
        const rotateSpeed = 0.05;
        return () => {
            if (!scope.aircraft)
                return;
            const direction = scope.camera.getWorldDirection(new THREE.Vector3()).normalize();
            const pos = scope.camera.position.clone();
            // 设置离相机的距离，太小容易在近端面以内导致看不见
            const airPosition = pos.addScaledVector(direction.clone(), 1);
            scope.aircraft.position.copy(airPosition);
            // 更改飞机的朝向
            // let airDirection = new THREE.Vector3(direction.x, 0, direction.z).applyAxisAngle(new Vector3(0, 1, 0), 3);
            scope.aircraft.lookAt(airPosition.addScaledVector(new THREE.Vector3(direction.x, 0, direction.z), 1000));
            // 如果按左键 向左旋转
            if (scope.controls.pressKeys.some((e) => scope.controls.keys.LEFT.includes(e)) && angle > -Math.PI / 18) {
                angle -= rotateSpeed;
            }
            // 如果按右键 向右旋转
            if (scope.controls.pressKeys.some((e) => scope.controls.keys.RIGHT.includes(e)) && angle < Math.PI / 18) {
                angle += rotateSpeed;
            }
            // 如果没有左右键，则归零
            if (!scope.controls.pressKeys.some((e) => scope.controls.keys.RIGHT.includes(e)) &&
                !scope.controls.pressKeys.some((e) => scope.controls.keys.LEFT.includes(e)) &&
                angle) {
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                angle > 0 ? (angle -= rotateSpeed) : (angle += rotateSpeed);
                if (angle > 0) {
                    angle -= rotateSpeed;
                    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                    angle < 0 ? (angle = 0) : '';
                }
                else {
                    angle += rotateSpeed;
                    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                    angle > 0 ? (angle = 0) : '';
                }
            }
            scope.aircraft.rotateOnWorldAxis(direction, angle);
            if (scope.aircraftMixer) {
                const deltaTime = Math.min(scope.clock?.getDelta() || 0.01);
                if (!scope.controls.shiftKey) {
                    scope.aircraftMixer.timeScale = 0.5;
                }
                else {
                    scope.aircraftMixer.timeScale = 1;
                }
                scope.aircraftMixer.update(deltaTime);
            }
        };
    })(this);
    setPersonMode() {
        this.controls.capsuleEnable = false;
        this.controls.enablePan = false;
        // this.controls.enableZoom = true;
        this.controls.isThirdPerspective = true;
        if (store.worldOctree) {
            this.collisionObject = new CollisionObject(this.controls, store.worldOctree, this.scene);
        }
        else {
            this.collisionObject?.dispose();
            this.collisionObject = undefined;
        }
    }
    setOperationMode(mode = 'sandTable') {
        this.setPrimaryMode();
        // if (this.operationMode === mode) return;
        this.operationMode = mode;
        store.mode = mode;
        switch (mode) {
            case 'sandTable':
                this.mapFocus();
                break;
            case 'fly':
                this.setFlyMode();
                this.mapFocus();
                break;
            case 'travel':
                // 开启行人模式
                this.setPersonMode();
                this.mapFocus();
                break;
            case 'cruise':
                // 开启巡视模式
                screenStore.updateSingleMapData({
                    key: 'operationMode',
                    value: 'cruise',
                });
                break;
            default:
                break;
        }
    }
    mapFocus() {
        this.container.focus();
    }
    // 获取/设置元素更新
    get elements() {
        return this._elements;
    }
    set elements(value) {
        // 更新元素
        if (!this.asyncTag) {
            this._elements = value;
            // this._handleElementChange();
            if (this.update) {
                this.update(MapUpdateType.element);
            }
        }
        else {
            this._tempList.push(value);
        }
    }
    // 获取/设置异步标志位
    get asyncTag() {
        return this._asyncTag;
    }
    set asyncTag(value) {
        this._asyncTag = value;
        if (!value) {
            this.elements = this._tempList.pop() || [];
            this._tempList = [];
        }
    }
    dealElementData(collectElements) {
        if (collectElements) {
            if (!store.modelLoaded) {
                for (const [key, data] of collectElements) {
                    this._collectElements.set(key, data);
                }
                return;
            }
            else {
                this._collectElements = new Map(collectElements);
            }
        }
        const collectArr = Array.from(this._collectElements);
        collectArr.sort((a, b) => {
            return (a[1]?.[0]?.weight || 0) - (b[1]?.[0]?.weight || 0);
        });
        const collectMap = new Map(collectArr);
        collectMap.forEach((value, key) => {
            this._handleElementChange(key, value);
        });
    }
    modelLoadedEvent() {
        this.dealElementData();
    }
    fetchOctree(url) {
        if (!store?.fetchOctree)
            return;
        return store?.fetchOctree(url);
    }
    // 渲染函数
    render() {
        // Debug
        if (this.debug) {
            this.stats?.update();
        }
        // // update intersects
        // this.intersects?.update(this._group);
        this.intersects?.update(this.scene);
        this.controls?.update();
        const time = Date.now();
        this.interval = time - this.preRenderTime;
        this.controls && (this.controls.interval = this.interval);
        if (this.interval > 500) {
            // 表示不流畅
            store.isSmooth = false;
            this.smoothTimes = 0;
        }
        else if (this.smoothTimes > 5) {
            // 超过5帧都是流畅时则判定为流畅
            !store.isSmooth && (store.isSmooth = true);
        }
        this.smoothTimes++;
        this.preRenderTime = time;
        store.preRenderTime = time;
        this.updateAircraft();
        // Render 首次render贴图 5-10s
        this.renderer?.render(this.scene, this.camera);
        this._labelRender?.render(this.scene, this.camera);
        TWEEN?.update();
    }
    setAsyncTag(value) {
        this.asyncTag = value;
    }
    /** 设置场景背景 */
    setSceneBackground(color = '#ffffff') {
        this.scene.background = new THREE.Color(color);
    }
    /** 添加自发光 */
    addAmbientLight() {
        const light = new THREE.AmbientLight();
        this.ambientLight = light;
        this.scene.add(light);
    }
    /** 删除自发光 */
    removeAmbientLight() {
        if (!this.ambientLight)
            return;
        this.ambientLight.dispose();
        this.scene.remove(this.ambientLight);
        this.ambientLight = undefined;
    }
    // 获取当前位置
    getPosition(event) {
        return this.intersects.getPosition(event);
    }
    // 根据坐标点返回世界坐标
    getWorldPosition(vertices) {
        return this.intersects.getWorldPosition(vertices);
    }
    resetWeather() {
        if (this.weather) {
            this._group.remove(this.weather);
            this.weather.dispose();
        }
        this.weather = new Weather({
            renderer: this.renderer,
            scene: this.scene,
            camera: this.camera,
        });
        this._group.add(this.weather);
    }
    // 设置俯视图
    setVerticalView() {
        this.controls.target.set(0, 0, 0);
        this.controls.object.position.set(0, 1000, 0);
        this.controls.minPolarAngle = 0;
        this.controls.maxPolarAngle = 0;
        this.controls.saveState();
    }
    // 设置主视角
    setMainAngle(mainAngle) {
        if (!mainAngle || !this.controls)
            return;
        this.mainAngle = mainAngle;
        this.controls.minPolarAngle = 0;
        this.controls.maxPolarAngle = Math.PI / 2 - Math.PI / 32;
        const { target, camera } = mainAngle;
        this.controls.object.position.set(camera.x, camera.y, camera.z);
        this.controls.target.set(target.x, target.y, target.z);
        this.controls.saveState();
    }
    getMainAngle() {
        return {
            target: this.controls.target,
            camera: this.camera.position,
        };
    }
    resetMainAngle() {
        // console.log('resetMainAngle', this.mainAngle);
        if (!this.mainAngle || !this.controls)
            return;
        this.controls.minPolarAngle = 0;
        this.controls.maxPolarAngle = Math.PI / 2 - Math.PI / 32;
        const { target, camera } = this.mainAngle;
        this.controls.object.position.set(camera.x, camera.y, camera.z);
        this.controls.target.set(target.x, target.y, target.z);
        this.controls.saveState();
    }
    // 快照
    getScreenshot() {
        const screenshot = this.renderer.domElement.toDataURL();
        return screenshot;
    }
    // 设置是否允许自动旋转
    setAutoRotate(val) {
        this.controls.autoRotate = val;
    }
    // 设置是否允许重力
    setEnableDamping(val) {
        this.controls.enableDamping = val;
    }
    getPointInMesh(id, vertices) {
        const object3D = this.scene?.getObjectByProperty('meshId', id);
        if (object3D) {
            return object3D.getPosition(vertices);
        }
        return null;
    }
    updateControls(cb) {
        cb(this.controls);
    }
    setInteractEnable(val) {
        this.intersects.enabled = val;
    }
    /**
     * 移动到某个mesh或者name为某个mesh的mesh
     * @param mesh
     */
    moveToMesh(mesh) {
        let object;
        if (typeof mesh === 'string') {
            object = this._group.getObjectByName(mesh);
        }
        else {
            object = mesh;
        }
        const box = new THREE.Box3();
        if (object) {
            const points = box.setFromObject(object);
            const size = points.getSize(new THREE.Vector3());
            const worldPosition = new THREE.Vector3();
            // 获得世界坐标，执行getWorldPosition方法，提取网格模型的世界坐标结果保存到参数worldPosition中
            object.getWorldPosition(worldPosition);
            object.visible = false;
            this._group.traverse((mesh) => {
                const regExp = new RegExp(object.name);
                if (regExp.test(mesh.name) && mesh !== object) {
                    mesh.visible = true;
                    mesh.isObserver = true;
                }
            });
            // this.controls.enabled = false;
            // this.camera.position.set(object.position.x - size.x, object.position.y, object.position.z - size.z);
            // this.camera.lookAt(object.position.x, object.position.y, object.position.z);
            const currentTarget = this.controls.target;
            const currentPosition = this.controls.object.position;
            const temp = this.controls.autoRotate;
            this.controls.enabled = false;
            this.controls.autoRotate = false;
            new TWEEN.Tween({
                x1: currentPosition.x,
                y1: currentPosition.y,
                z1: currentPosition.z,
                x2: currentTarget.x,
                y2: currentTarget.y,
                z2: currentTarget.z,
            })
                .to({
                x1: worldPosition.x - size.x,
                y1: worldPosition.y,
                z1: worldPosition.z - size.z,
                x2: worldPosition.x,
                y2: worldPosition.y,
                z2: worldPosition.z,
            }, 2000)
                .onUpdate((obj) => {
                this.controls.object.position.set(obj.x1, obj.y1, obj.z1);
                this.controls.target.set(obj.x2, obj.y2, obj.z2);
            })
                .onComplete(() => {
                this.controls.enabled = true;
                this.controls.autoRotate = temp;
            })
                .start();
            // this.controls.object.position.set(worldPosition.x - size.x, worldPosition.y, worldPosition.z - size.z);
            // this.controls.target.set(worldPosition.x, worldPosition.y, worldPosition.z);
            // this.controls.enabled = true;
        }
    }
    _handleElementChange(key, data) {
        const _elementMap = new Map();
        const _addList = [];
        function _DP(elementMap, elements, id, group, that) {
            elements.map((element, index) => {
                const _id = id + element.type + (element.id || '' + index + new Date().getTime()); // 随机值方式优化
                if (elementMap.get(_id)) {
                    const object3D = group.getObjectByName(elementMap.get(_id));
                    if (object3D?.update) {
                        object3D.update({
                            ...element,
                            name: _id,
                            setVerticalView: that.setVerticalView.bind(that),
                            setMainAngle: that.setMainAngle.bind(that),
                            getPointInMesh: that.getPointInMesh.bind(that),
                            setAsyncTag: that.setAsyncTag.bind(that),
                        });
                        _elementMap.set(_id, object3D.uuid);
                    }
                    else {
                        const type = element.type;
                        object3D?.dispose();
                        const newObject3D = new Objects[type]({
                            ...element,
                            name: _id,
                            setVerticalView: that.setVerticalView.bind(that),
                            setMainAngle: that.setMainAngle.bind(that),
                            getPointInMesh: that.getPointInMesh.bind(that),
                            setAsyncTag: that.setAsyncTag.bind(that),
                        });
                        group.add(newObject3D);
                        _elementMap.set(_id, newObject3D.uuid);
                    }
                    elementMap.delete(_id);
                }
                else {
                    if (_elementMap.get(_id)) {
                        const object3D = group.getObjectByName(_elementMap.get(_id));
                        if (object3D?.update) {
                            object3D.update({
                                ...element,
                                name: _id,
                                setVerticalView: that.setVerticalView.bind(that),
                                setMainAngle: that.setMainAngle.bind(that),
                                getPointInMesh: that.getPointInMesh.bind(that),
                                setAsyncTag: that.setAsyncTag.bind(that),
                            });
                            _elementMap.set(_id, object3D.uuid);
                        }
                        else {
                            const type = element.type;
                            object3D?.dispose();
                            const newObject3D = new Objects[type]({
                                ...element,
                                name: _id,
                                setVerticalView: that.setVerticalView.bind(that),
                                setMainAngle: that.setMainAngle.bind(that),
                                getPointInMesh: that.getPointInMesh.bind(that),
                                setAsyncTag: that.setAsyncTag.bind(that),
                            });
                            group.add(newObject3D);
                            _elementMap.set(_id, newObject3D.uuid);
                        }
                        console.warn(`type:${element.type} id:${element.id}重复，元素被覆盖`);
                    }
                    else {
                        _addList.push({
                            element,
                            name: _id,
                        });
                        // const type: MeshType = element.type;
                        // const object3D = new Objects[type]({
                        //   ...element,
                        //   name: _id,
                        //   setVerticalView: that.setVerticalView.bind(that),
                        //   setMainAngle: that.setMainAngle.bind(that),
                        //   getPointInMesh: that.getPointInMesh.bind(that),
                        // });
                        // _elementMap.set(_id, object3D.uuid);
                        // group.add(object3D);
                        elementMap.delete(_id);
                    }
                }
                // if (element.children && element.children.length > 0) {
                //   _DP(elementMap, element.children, id, group, that);
                // }
            });
        }
        const UpdateDiffOpration = () => {
            if (!this._elementMap.has(key)) {
                this._elementMap.set(key, new Map());
            }
            const elementKeyMap = this._elementMap.get(key);
            _DP(elementKeyMap, data, '', this._group, this);
            // DP(this._elements, '', this._group);
            elementKeyMap.forEach((uuid) => {
                // 删除旧Map中剩余元素
                this._group.getObjectByName(uuid)?.dispose();
                // element.dispose();
            });
            _addList.map((item) => {
                const { element, name } = item;
                const type = element.type;
                const object3D = new Objects[type]({
                    ...element,
                    name: name,
                    setVerticalView: this.setVerticalView.bind(this),
                    setMainAngle: this.setMainAngle.bind(this),
                    getPointInMesh: this.getPointInMesh.bind(this),
                    setAsyncTag: this.setAsyncTag.bind(this),
                });
                _elementMap.set(name, object3D.uuid);
                this._group.add(object3D);
            });
            // this._elementMap = _elementMap; // 更新Map数据
            this._elementMap.set(key, _elementMap);
        };
        this.testTimer(UpdateDiffOpration);
        this.setLog('group中所有元素', this._group.children);
        this.setLog('源数据', this.elements);
        this.setLog('map数据', this._elementMap);
    }
    _resize() {
        const height = this.container.clientHeight;
        const width = this.container.clientWidth;
        if (height !== 0) {
            this.camera.aspect = width / height;
            this.camera.updateProjectionMatrix();
            this.renderer?.setSize(width, height);
            this._labelRender.setSize(width, height);
        }
        return this;
    }
    zoomReset() {
        // 还原controls
        // this.controls?.reset();
        const initTarget = this.controls?.target0;
        const initPosition = this.controls?.position0;
        const currentTarget = this.controls.target;
        const currentPosition = this.controls.object.position;
        const temp = this.controls.autoRotate;
        this.controls.enabled = false;
        this.controls.autoRotate = false;
        new TWEEN.Tween({
            x1: currentPosition.x,
            y1: currentPosition.y,
            z1: currentPosition.z,
            x2: currentTarget.x,
            y2: currentTarget.y,
            z2: currentTarget.z,
        })
            .to({ x1: initPosition.x, y1: initPosition.y, z1: initPosition.z, x2: initTarget.x, y2: initTarget.y, z2: initTarget.z }, 2000)
            .onUpdate((obj) => {
            this.controls.object.position.set(obj.x1, obj.y1, obj.z1);
            this.controls.target.set(obj.x2, obj.y2, obj.z2);
            this.camera.lookAt(obj.x2, obj.y2, obj.z2);
        })
            .onComplete(() => {
            this.controls.enabled = true;
            this.controls.autoRotate = temp;
        })
            .start();
        return this;
    }
    zoomIn(num = 1) {
        const scale = num + 1;
        const { x, y, z } = this.controls.object.position;
        const x1 = x - this.controls.target.x;
        const y1 = y - this.controls.target.y;
        const z1 = z - this.controls.target.z;
        const temp = this.controls.autoRotate;
        this.controls.object.position.set(x1 / scale + this.controls.target.x, y1 / scale + this.controls.target.y, z1 / scale + this.controls.target.z);
        this.controls.autoRotate = temp;
        return this;
    }
    zoomOut(num = 1) {
        const scale = num + 1;
        const { x, y, z } = this.controls.object.position;
        const x1 = x - this.controls.target.x;
        const y1 = y - this.controls.target.y;
        const z1 = z - this.controls.target.z;
        const temp = this.controls.autoRotate;
        this.controls.object.position.set(x1 * scale + this.controls.target.x, y1 * scale + this.controls.target.y, z1 * scale + this.controls.target.z);
        this.controls.autoRotate = temp;
        return this;
    }
    cameraUp(num = 0.1) {
        this.camera.position.y += num;
    }
    cameraDown(num = 0.1) {
        this.camera.position.y -= num;
    }
    // 坐标转换，dom => canvas
    clientToMapPosition(x, y) {
        const rect = this.container.getBoundingClientRect();
        // Standard x and y in standard coordinate, range from [-1, 1]
        const standardX = ((x - rect.left) / rect.width) * 2 - 1;
        const standardY = -((y - rect.top) / rect.height) * 2 + 1;
        // Get identity vector from camera to target point
        const vec = new THREE.Vector3().set(standardX, standardY, 0.5);
        vec.unproject(this.camera);
        vec.sub(this.camera.position).normalize();
        // Get vector from camera to XY plane
        vec.multiplyScalar(-this.camera.position.z / vec.z);
        // Get intersect on XY plane
        const pos = new THREE.Vector3().copy(this.camera.position).add(vec);
        return { x: pos.x, y: pos.y };
    }
    // 移动到某个点
    moveToPoint({ x, y, z, duration = 1000, cb }) {
        // target: this.controls.target,
        //   camera: this.camera.position,
        if (!this.controls)
            return;
        const temp = this.controls.autoRotate;
        this.controls.enabled = false;
        this.controls.autoRotate = false;
        new TWEEN.Tween({
            x1: this.controls.object.position.x,
            y1: this.controls.object.position.y,
            z1: this.controls.object.position.z,
            x2: this.controls.target.x,
            y2: this.controls.target.y,
            z2: this.controls.target.z,
        })
            .to({
            x1: this.mainAngle.camera.x - this.mainAngle.target.x + x,
            y1: this.mainAngle.camera.y - this.mainAngle.target.y + y,
            z1: this.mainAngle.camera.z - this.mainAngle.target.z + z,
            x2: x,
            y2: y,
            z2: z,
        }, duration)
            .onUpdate((obj) => {
            if (this.controls) {
                this.controls.object.position.set(obj.x1, obj.y1, obj.z1);
                this.controls.target.set(obj.x2, obj.y2, obj.z2);
            }
        })
            .onComplete(() => {
            if (this.controls) {
                this.controls.enabled = true;
                this.controls.autoRotate = temp;
                if (cb && typeof cb === 'function') {
                    cb();
                }
            }
        })
            .start();
    }
    formatPointsToPlatform(vertices) {
        const vectorList = vertices.map((item) => {
            // 坐标点列表
            const vector = new THREE.Vector3(item.x, item.y, item.z);
            return vector;
        });
        let index = 2;
        for (let i = index; i < vertices.length; i++) {
            // 判断共线情况
            if (Number(new THREE.Vector3().subVectors(vectorList[0], vectorList[1]).dot(new THREE.Vector3().subVectors(vectorList[1], vectorList[index]))) === 0) {
                index++;
            }
            else {
                break;
            }
        }
        const plane = new THREE.Plane().setFromCoplanarPoints(vectorList[0], vectorList[1], vectorList[index]); // 三维空间中的二维平面
        vectorList.map((item) => {
            // 将其他点投影到该平面
            const vector = new THREE.Vector3();
            plane.projectPoint(item, vector);
            return vector;
        });
        return vectorList;
    }
    resetElements(elements) {
        this.elements = elements;
        if (this.update) {
            this.update(MapUpdateType.scene);
        }
    }
    // 在debug模式下允许打开log
    setLog(...rest) {
        if (this.debug) {
            console.log(...rest);
        }
    }
    setSunPosition(angle, uniforms = {}, wrapAngle = 0) {
        this.weather?.updateSky(angle, uniforms, wrapAngle);
    }
    setWeather(weather, config) {
        this.weather?.setWeather(weather, config);
    }
    // 在debug模式下允许事件耗时测试
    testTimer(cb) {
        if (this.debug) {
            console.time(`${cb.name}函数测试`);
            cb?.();
            console.timeEnd(`${cb.name}函数测试`);
        }
        else {
            cb?.();
        }
    }
    MapType(type) {
        const maptype = {
            click: 'onClick',
            mousedown: 'onMouseDown',
            mouseup: 'onMouseUp',
            mousemove: 'onMouseMove',
            mouseenter: 'onMouseEnter',
            mouseleave: 'onMouseLeave',
        };
        return maptype[type];
    }
    // 事件处理，拿到具体元素
    EventHandler(event) {
        const type = event.type;
        const target = event.mapTarget; // 当前元素
        const targets = event.mapTargets; // 当前射线穿过的所有元素
        const position = event.mapPosition; // 当前位置
        const worldPosition = event.worldPosition; // 世界坐标
        const onType = this.MapType(type);
        const maptype = onType;
        if (this[maptype] && typeof this[maptype] === 'function') {
            this[maptype]?.(target, targets, position, worldPosition);
        }
        if (target && typeof target[onType] === 'function') {
            target[onType](target, targets, position, worldPosition);
        }
    }
    // 工具group清除
    cleanToolGroup() {
        this._toolGroup.children?.map((obj) => {
            obj?.dispose?.();
        });
        this._toolGroup.clear();
    }
    dispose() {
        // remove requestAnimation
        window.cancelAnimationFrame(this.animateId);
        // remove eventListener
        this.intersects.removeEventListener('mousedown', this.EventHandler);
        this.intersects.removeEventListener('mouseup', this.EventHandler);
        this.intersects.removeEventListener('mousemove', this.EventHandler);
        this.intersects.removeEventListener('click', this.EventHandler);
        this.intersects.removeEventListener('mouseenter', this.EventHandler);
        this.intersects.removeEventListener('mouseleave', this.EventHandler);
        window.removeEventListener('resize', this._resize, false);
        if (this.collisionObject) {
            this.collisionObject.dispose();
            this.collisionObject = undefined;
        }
        this._group.children?.map((obj) => {
            obj?.dispose?.();
        });
        this._toolGroup.children?.map((obj) => {
            obj?.dispose?.();
        });
        this.scene.traverse((obj) => {
            if (obj instanceof THREE.Mesh) {
                obj.geometry.dispose();
                obj.material.dispose();
            }
            else {
                if (obj.parent) {
                    obj?.parent?.remove(obj);
                }
                obj?.clear();
            }
        });
        store.isSmooth = true;
        this.intersects.dispose();
        this.controls.dispose();
        this.renderer.domElement.remove();
        this._labelRender.domElement.remove();
        if (this.stats) {
            this.stats.domElement.remove();
        }
        this.renderer.forceContextLoss();
        this.renderer.dispose();
        this.scene.clear();
        // remove elements
        this.scene = null;
        this.camera = null;
        this.controls = null;
        this.renderer.domElement = null;
        this._labelRender.domElement = null;
        this._labelRender = null;
        this.renderer = null;
    }
}
export default BaseMap;
